import React from 'react';
import PDFUpload from '../components/upload/PDFUpload';

const PDFUploadPage: React.FC = () => {
    return (
        <div style={{ minHeight: '100vh', backgroundColor: '#f7fafc' }}>
            <div style={{ padding: '20px 0' }}>
                <PDFUpload />
            </div>
        </div>
    );
};

export default PDFUploadPage;
